const PaymentGatewayNewTools = () => {
  return (
    <>
      <div className="pay-gw-payment-tools-area">
        <div className="container">
          <div className="pt-60 pb-120 position-relative z-1">
            <img
              src="assets/img/home_34/payment-mobile.png"
              alt=""
              className="shape-1 position-absolute z--1 img-fluid"
            />
            <div className="row align-items-center justify-content-between">
              <div className="col-xxl-5 col-lg-6">
                <h2 className="pay-gw-title pay-gw-color fs-42 ff-risk-pri">
                  One platform all the tools you need to grow
                </h2>
                <p className="mb-30">
                  One product, all the payment flows — unlike other providers
                  Rainforest can be used to send money
                </p>
                <a
                  href="request-demo.html"
                  className="btn pay-bg-color text-white rounded-3 mb-60"
                >
                  Started Free Trail
                </a>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-6">
                <div className="pay-gw-user mb-40">
                  <div className="d-flex align-items-center gap-4 mb-20">
                    <img
                      src="assets/img/home_34/user-1.png"
                      alt=""
                      className="img-fluid"
                    />
                    <h6 className="pay-gw-color fs-36 mb-0">
                      12m <span className="fs-16 fw-500"> Active User</span>
                    </h6>
                  </div>
                  <p className="mb-0">
                    Excellent digital agency with highly skilled employees
                    offers quality.
                  </p>
                </div>
                <div className="pay-gw-user">
                  <div className="d-flex align-items-center gap-4 mb-20">
                    <img
                      src="assets/img/home_34/user-2.png"
                      alt=""
                      className="img-fluid"
                    />
                    <h6 className="pay-gw-color fs-36 mb-0">
                      06m <span className="fs-16 fw-500"> Active User</span>
                    </h6>
                  </div>
                  <p className="mb-0">
                    Excellent digital agency with highly skilled employees
                    offers quality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentGatewayNewTools;
